// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"1":function(container,depth0,helpers,partials,data) {
    return " brec-container--app-drawer-open";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"brec-container brec-container--app"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"view") : depth0)) != null ? lookupProperty(stack1,"mainNavDrawerOpen") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":12},"end":{"line":2,"column":83}}})) != null ? stack1 : "")
    + "\">\n  <header inject=\"nav\"></header>\n  <div class=\"brec-container brec-container--global\">\n    <main class=\"brec-main\" role=\"main\">\n      <section inject=\"appointment-bill-view\"></section>\n    </main>\n    <aside inject=\"aside\"></aside>\n  </div>\n  <footer inject=\"footer\"></footer>\n</div>\n";
},"useData":true});
